var Theme = Theme || {};

Theme.SolrSavedSearches = (function ($) {
    var baseSiteUrl = $('#hfSiteURL').val();

    return {
        init: _init
    };

    function _init() {
        initTableSort();
        deleteSavedSearchClickEvent();
        savedSearchAlertFrequencyChangeEvent();
        editSavedSearchName();
        cancelSavedSearchNameEdit();
        saveNewNameForSavedSearch();
        saveNewSearchNameOnEnterPress();
        triggerSaveSearchModelOnRedirect();
    }

    function initTableSort() {
        $('.solrSearchSaveWidget table.tablesorter').tablesorter({
            theme: 'default',
            delayInit: true,
            ignoreCase: true,
            headers: { 4: { sorter: false } },
            sortList: [[0, 0]]
        });

    }

    function deleteSavedSearchClickEvent() {
        $('.solrSearchSaveWidget .js-save-search-delete').on('click', function () {
            _deleteSaveSearch($(this));
        });
    }

    function savedSearchAlertFrequencyChangeEvent() {
        $('.solrSearchSaveWidget .js-alert-frequency').on('change', function () {
            _changeUserAlert($(this));
        });
    }

    function editSavedSearchName() {
        $('.solrSearchSaveWidget .js-save-search-rename-rename').on('click', function () {
            var $parentElem = $(this).closest('td');
            var $searchNameLnk = $parentElem.find('.js-save-search-name-link');

            $searchNameLnk.addClass('hide');
            $parentElem.find('.js-save-search-input').val($searchNameLnk.text()).addClass('active').focus();
            $parentElem.find('.js-save-search-rename-cancel').addClass('active');
            $parentElem.find('.js-save-search-rename-save').addClass('active');
            $(this).addClass('hide');
        });
    }

    function cancelSavedSearchNameEdit() {
        $('.solrSearchSaveWidget .js-save-search-rename-cancel').on('click', function (e) {
            var $parentElem = $(e.target).closest('td');
            _hideEditableSearchNameInterface($parentElem);
            _unhideSearchNameAndRenameLink($parentElem);
        });
    }

    function saveNewNameForSavedSearch() {
        $('.solrSearchSaveWidget .js-save-search-rename-save').on('click', function (e) {
            var $saveLnk = $(e.target);
            var $parentElem = $saveLnk.closest('td');
            var $searchNameInput = $parentElem.find('.js-save-search-input');
            var $userSearchId = $saveLnk.closest('tr').data('usersearchid');
            var $newSearchName = $searchNameInput.val();

            if ($newSearchName.length) {
                _renameSaveSearch($newSearchName, $userSearchId);
                _updateSearchNameText($parentElem, $newSearchName);
                _hideEditableSearchNameInterface($parentElem);
                _unhideSearchNameAndRenameLink($parentElem);
            }
        });
    }

    function saveNewSearchNameOnEnterPress() {
        $('.solrSearchSaveWidget .js-save-search-input').on('keypress', function (e) {
            var $eventTarget = $(e.target);
            var $parentElem = $eventTarget.closest('td');
            var $usersearchid = $parentElem.closest('tr').data('usersearchid');
            var $newSearchName = $eventTarget.val();

            if (e.key === 'Enter') {
                e.preventDefault();

                if ($newSearchName.length) {
                    _renameSaveSearch($newSearchName, $usersearchid);
                    _updateSearchNameText($parentElem, $newSearchName);
                    _hideEditableSearchNameInterface($parentElem);
                    _unhideSearchNameAndRenameLink($parentElem);
                }
            }
        });
    }

    function _deleteSaveSearch($delElem) {
        var ajaxUrl = `//${baseSiteUrl}/Solr/DeleteSolrSearchInfo`;
        var $parentElem = $delElem.closest('tr');
        var id = $parentElem.data('usersearchid');
        var userAlertId = $parentElem.data('useralertid');

        SCM.Ajax.post(ajaxUrl, { userSearchId: id, userAlertId: userAlertId })
            .expectActionResultModel()
            .ensureSuccess()
            .then(function () {
                $parentElem.remove();
            })
            .catch(console.error);
    }

    function _changeUserAlert($upElem) {
        var ajaxUrl = `//${baseSiteUrl}/Solr/UpdateUserAlert`;
        var $parentElem = $upElem.closest('tr');
        var id = $parentElem.data('usersearchid');
        var userAlertId = $parentElem.data('useralertid');
        var scheduleId = $upElem.val();

        SCM.Ajax.post(ajaxUrl, { userSearchId: id, userAlertId: userAlertId, scheduleId: scheduleId })
            .expectActionResultModel()
            .ensureSuccess()
            .then(function (result) {
                $parentElem.data('useralertid', result.ReturnId);
            })
            .catch(console.error);
    }

    function _renameSaveSearch(searchName, userSearchId) {
        var ajaxUrl = `//${baseSiteUrl}/Solr/RenameSolrSearchInfo`;

        SCM.Ajax.post(ajaxUrl, { searchName: searchName, userSearchId: userSearchId })
            .expectActionResultModel()
            .ensureSuccess()
            .catch(console.error);
    }

    function _updateSearchNameText($parentElem, $newSearchName) {
        $parentElem.find('.js-save-search-name-link').text($newSearchName);
    }

    function _hideEditableSearchNameInterface($parentElem) {
        $parentElem.find('.js-save-search-input').removeClass('active');
        $parentElem.find('.js-save-search-rename-cancel').removeClass('active');
        $parentElem.find('.js-save-search-rename-save').removeClass('active');
    }

    function _unhideSearchNameAndRenameLink($parentElem) {
        $parentElem.find('.js-save-search-name-link').removeClass('hide');
        $parentElem.find('.js-save-search-rename-rename').removeClass('hide');
    }

    function triggerSaveSearchModelOnRedirect() {
        var saveSearch = SCM.JSUtility.getParamFromHash('triggerSaveSearch');
        if (saveSearch === '1') {
            $('.lnkSaveSolrSearch').trigger('click');
            SCM.JSUtility.removeParamFromHash('triggerSaveSearch');
        }
    }

})(jQuery);